/* THIS FILE IS GENERATED. DO NOT EDIT */

import type { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { withStandaloneInstanceof } from '@/utils/withInstanceofProp';
import { mergeProps } from '@/utils/merge';
import { ErrorBoundary } from 'base/components/ErrorBoundary';
import { StandaloneSavedArticles as ResolvedStandaloneSavedArticles } from 'base/components/standalone/SavedArticles';

export const SavedArticles: typeof ResolvedStandaloneSavedArticles = withStandaloneInstanceof((props) => {
    return (
        <ErrorBoundary>
            <ResolvedStandaloneSavedArticles {...props} />
        </ErrorBoundary>
    );
});

export type SavedArticlesProps = PropsFromComponent<typeof SavedArticles>;

/** @deprecated Use slot architecture instead */
export const SavedArticlesWith = (extras: DynamicStandaloneExtras): typeof SavedArticles => {
    return function SavedArticles(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'SavedArticles');
        return <ResolvedStandaloneSavedArticles {...mergeProps({ options: { theme } }, props)} />;
    }
}